export default __webpack_public_path__ + "static/media/yamaha.483cd425.png";